import { createSlice } from "@reduxjs/toolkit";

const selectedManagementSlice = createSlice({
  name: "selectedManagement",
  initialState: null,
  reducers: {
    setSelectedManagement: (state, action) => {
      return action.payload;
    },
    clearSelectedManagement: () => {
      return null;
    },
  },
});

export const { setSelectedManagement, clearSelectedManagement } =
  selectedManagementSlice.actions;
export const selectedSelectedManagement = (state) => state.selectedManagement;

export default selectedManagementSlice.reducer;
